import { Nullable } from 'typescript-nullable';
import Pubmatic from './partners/pubmatic';
import Rubicon from './partners/rubicon';
import SlotName from './common/slot-name';
import IndexExchange from './partners/index-exchange';
import MSFT from './partners/msft';
import Amx from './partners/amx';
import Nexx360 from './partners/nexx360';
import Ozone from './partners/ozone';
import { getSizesBySlotName } from './media-types/banner';
import ScreenSize from './common/screen-size';
import Criteo from './partners/criteo';
import Adyoulike from './partners/adyoulike';
import DeviceType from './common/device-type';
import PageType from './common/page-type';

const slotConfig = (
    pageType: PageType,
    deviceType: DeviceType,
    screenSize: ScreenSize,
    slotName: SlotName,
    categoryL1: Nullable<string>,
    categoryL2: Nullable<string>,
    categoryL3: Nullable<string>,
    keywords: Nullable<string>,
    vipAdId: Nullable<number>,
    isNexx360?: boolean
) => {
    if (Nullable.isNone(slotName)) {
        return;
    }

    if (slotName === SlotName.premiumNative1) {
        return {
            code: 'premiumNative1',
            mediaTypes: {
                native: {},
            },
            bids: [],
        };
    }

    if (slotName === SlotName.topTakeover) {
        return {
            code: 'top_takeover',
            mediaTypes: {
                banner: {
                    sizes: [
                        [970, 250],
                        [2000, 255],
                    ],
                },
            },
            bids: [],
        };
    }

    const sizes = getSizesBySlotName(pageType, deviceType, slotName, screenSize);

    const bids = [
        new Rubicon(
            pageType,
            deviceType,
            slotName,
            screenSize,
            keywords,
            categoryL1,
            categoryL2,
            categoryL3
        ),
        new MSFT(
            pageType,
            deviceType,
            slotName,
            screenSize,
            keywords,
            categoryL1,
            categoryL2,
            categoryL3,
            vipAdId
        ),
        new IndexExchange(
            pageType,
            deviceType,
            slotName,
            screenSize,
            keywords,
            categoryL1,
            categoryL2,
            categoryL3
        ),
        new Pubmatic(
            pageType,
            deviceType,
            slotName,
            screenSize,
            keywords,
            categoryL1,
            categoryL2,
            categoryL3
        ),
        new Ozone(
            pageType,
            deviceType,
            slotName,
            screenSize,
            keywords,
            categoryL1,
            categoryL2,
            categoryL3
        ),
        new Amx(
            pageType,
            deviceType,
            slotName,
            screenSize,
            keywords,
            categoryL1,
            categoryL2,
            categoryL3
        ),
        ...(isNexx360
            ? [
                  new Nexx360(
                      pageType,
                      deviceType,
                      slotName,
                      screenSize,
                      keywords,
                      categoryL1,
                      categoryL2,
                      categoryL3
                  ),
              ]
            : [
                  new Adyoulike(
                      pageType,
                      deviceType,
                      slotName,
                      screenSize,
                      keywords,
                      categoryL1,
                      categoryL2,
                      categoryL3
                  ),
                  new Criteo(
                      pageType,
                      deviceType,
                      slotName,
                      screenSize,
                      keywords,
                      categoryL1,
                      categoryL2,
                      categoryL3
                  ),
              ]),
    ]
        .map((partner) => partner.toObject())
        .filter(Nullable.isSome);

    return {
        code: slotName.toString(),
        bids,
        mediaTypes: {
            banner: {
                sizes,
            },
        },
        sizes,
    };
};

export default slotConfig;
